import { render, staticRenderFns } from "./wsnham.vue?vue&type=template&id=a5a33d20&scoped=true&"
import script from "./wsnham.vue?vue&type=script&lang=js&"
export * from "./wsnham.vue?vue&type=script&lang=js&"
import style0 from "./wsnham.vue?vue&type=style&index=0&id=a5a33d20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a33d20",
  null
  
)

export default component.exports